/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import { startCase, capitalize, lowerCase } from 'lodash';

const ListGroupItemSurvivorInteraction = ({ data }) => {
  const detailObject = data.attributes.detailObject
    ? JSON.parse(data.attributes.detailObject)
    : data.attributes.detail
      ? data.attributes.detail
      : {};

  return (
    <span className="ml-2">
      {detailObject.contactAttemptType &&
        `${capitalize(startCase(detailObject.contactAttemptType))} interaction `}
      {data.relationships.referenceStatus &&
        ` was ${lowerCase(data.relationships.referenceStatus.attributes.statusLabel)}.`}{' '}
      {data.attributes.statusLabel &&
        ` was ${lowerCase(data.attributes.statusLabel)}.`}{' '}
      {detailObject.survivorContacted === 'yes' && 'Interacted with client.'}{' '}
      {!!detailObject.otherContactType &&
        'Interacted with client support system.'}
    </span>
  );
};

ListGroupItemSurvivorInteraction.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ListGroupItemSurvivorInteraction;
